exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[data-v-e0a219a8] {\r\n  width: 100%;\r\n  height: 40px;\r\n  margin-top: 15 px;\n}\n.new-item[data-v-e0a219a8] {\r\n  padding-left: 52px;\n}\n.align-span[data-v-e0a219a8] {\r\n  overflow: hidden;\r\n  display: block;\r\n  padding: 0 4px 0 10px;\n}\n.remove[data-v-e0a219a8] {\r\n  float: left;\n}\n.clear[data-v-e0a219a8] {\r\n  clear: both;\n}\nli[data-v-e0a219a8] {\r\n  margin-top: 5px;\n}\nul[data-v-e0a219a8] {\r\n  padding: 0;\r\n  margin: none;\r\n  list-style-type: none;\n}\r\n", ""]);

// exports
